import T from "../theme";
import { SPONSORS } from "../data";
import Reveal from "../components/Reveal";
import { Section, SectionLabel } from "../components/Section";

export default function PetitionSection() {
  const tiers = [...new Set(SPONSORS.map((s) => s.tier))];
  return (
    <Section id="petition" style={{ background: T.bg0 }}>
      <div className="section-pad" style={{ maxWidth: 1000, margin: "0 auto" }}>
        <Reveal><SectionLabel text="Petition" /></Reveal>
        <Reveal delay={0.05}>
          <h2 style={{ color: T.white, fontSize: "clamp(28px,4vw,52px)", fontWeight: 900, margin: "0 0 48px", letterSpacing: -1 }}>
            Sign Our Petition
          </h2>
        </Reveal>

        {tiers.map((tier, ti) => {
          const list = SPONSORS.filter((s) => s.tier === tier);
          const sz   = tier === "Platinum" ? 22 : tier === "Gold" ? 18 : 14;
          return (
            <div key={tier} style={{ marginBottom: 48 }}>
              <Reveal delay={ti * 0.08}>
                <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 20 }}>
                  <span style={{
                    fontFamily: T.mono, fontSize: 10, letterSpacing: 3, textTransform: "uppercase",
                    color: tier === "Platinum" ? T.blue : tier === "Gold" ? "#d4a017" : T.gray2,
                  }}>{tier}</span>
                  <div style={{ flex: 1, height: 1, background: tier === "Platinum" ? T.border : T.borderDim }} />
                </div>
              </Reveal>
              <div className="sponsors-row">
                {list.map((sp, si) => (
                  <Reveal key={si} delay={ti * 0.08 + si * 0.04}>
                    <div style={{
                      background: T.bgCard, border: `1px solid ${T.borderDim}`,
                      borderRadius: 6, padding: `${tier === "Platinum" ? 24 : 16}px 28px`,
                      display: "flex", alignItems: "center", justifyContent: "center", minWidth: 160,
                    }}>
                      <span style={{ color: T.gray1, fontWeight: 700, fontSize: sz, letterSpacing: 0.5 }}>{sp.name}</span>
                    </div>
                  </Reveal>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </Section>
  );
}
